import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { ICrmSurveyFormQuestionActionTypes } from "../../action-types/crm-survey/ICrmSurveyFormQuestionActionTypes";
import { ICrmSurveyFormQuestionReducer } from "../../page-state-model/crm-survey/ICrmSurveyFormQuestionReducer";
const iniState: ICrmSurveyFormQuestionReducer = {
    status: ePageBaseStatus.is_not_initialization,
    crmSurveyFormQuestions: [],
    crmSurveyFormQuestionSelectedIds:[]
}
export const crmSurveyFormQuestionReducer = (state: ICrmSurveyFormQuestionReducer = iniState, action: ICrmSurveyFormQuestionActionTypes): ICrmSurveyFormQuestionReducer => {
    switch (action.type) {
        case "CRM_SURVEY_FORM_QUESTION_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "CRM_SURVEY_FORM_QUESTION_LOAD_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                crmSurveyFormQuestions: action.payload
            }
        case "CRM_SURVEY_FORM_QUESTION_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                crmSurveyFormQuestions: []
            }
        case "CRM_SURVEY_FORM_QUESTION_CHANGE_SELECTED_IDS":
            return {
                ...state,
                crmSurveyFormQuestionSelectedIds: action.payload
            }
        default:
            return state;
    }
}